export const additionProduct = [
  {
    path: `/AdditionProduct`,
    name: `AdditionProduct`,
    redirect: `/AdditionProduct/add`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/AdditionProduct/add/:projectId/:groupId/:groupName/:isService/:routerPath',
        name: 'AdditionProduct/add',
        component: () => import('@/views/additionproduct/AdditionProduct')
      }
    ]
  }
];
